<div class="form-container">
    <div class="card-container">
        <div class="card-title">Report Download</div>

        <!-- Filter Section -->
        <div class="filter-section">
            <div class="filter-row">
                <!-- Report Type Selection -->
                <div class="filter-item">
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Report Type</mat-label>
                        <mat-select [(ngModel)]="selectedReportType" (selectionChange)="onReportTypeChange()">
                            <mat-option *ngFor="let type of reportTypes" [value]="type.value">
                                {{ type.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- From Date -->
                <div class="filter-item">
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>From Date</mat-label>
                        <input matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate"
                            (dateChange)="onFilterChange()">
                        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                        <mat-datepicker #fromPicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <!-- To Date -->
                <div class="filter-item">
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>To Date</mat-label>
                        <input matInput [matDatepicker]="toPicker" [(ngModel)]="toDate"
                            (dateChange)="onFilterChange()">
                        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
                        <mat-datepicker #toPicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <!-- Status Filter -->
                <div class="filter-item">
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Status</mat-label>
                        <mat-select [(ngModel)]="selectedStatus" (selectionChange)="onFilterChange()">
                            <mat-option *ngFor="let status of statusOptions" [value]="status">
                                {{ status }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="action-buttons">
                <button type="button" class="clear-button" (click)="clearFilters()">
                    <mat-icon>refresh</mat-icon>
                    <span>Clear Filters</span>
                </button>
                <button type="button" class="download-button" [matMenuTriggerFor]="downloadMenu">
                    <mat-icon>download</mat-icon>
                    <span>Download</span>
                    <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #downloadMenu="matMenu">
                    <button mat-menu-item (click)="downloadReport('excel')">
                        <mat-icon>table_chart</mat-icon>
                        <span>Download as Excel (.xlsx)</span>
                    </button>
                    <button mat-menu-item (click)="downloadReport('csv')">
                        <mat-icon>description</mat-icon>
                        <span>Download as CSV (.csv)</span>
                    </button>
                </mat-menu>
            </div>
        </div>

        <!-- Data Preview Section -->
        <div class="preview-section">
            <div class="preview-header">
                <span class="preview-title">Data Preview</span>
                <span class="record-count">{{ reportData.length }} records found</span>
            </div>

            <!-- Loading Indicator -->
            <div *ngIf="isLoading" class="loading-container">
                <div class="loading-spinner"></div>
                <span>Loading data...</span>
            </div>

            <!-- Data Table -->
            <div *ngIf="!isLoading" class="card-status-container">
                <table class="shipment-table">
                    <thead class="table-header">
                        <tr>
                            <th *ngFor="let col of tableColumns" class="table-header">{{ col.label }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of reportData" class="table-row">
                            <td *ngFor="let col of tableColumns" class="table-cell">
                                <span *ngIf="col.key !== 'status'">{{ data[col.key] }}</span>
                                <span *ngIf="col.key === 'status'" class="status-badge" [ngClass]="getStatusClass(data[col.key])">
                                    {{ data[col.key] }}
                                </span>
                            </td>
                        </tr>
                        <tr *ngIf="reportData.length === 0">
                            <td [attr.colspan]="tableColumns.length" class="no-data">
                                No data found. Please adjust your filters.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
